<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12" class="pr-6">
      <card-title-row :straightTitle="additionalModuleName" class="pt-3 pb-5" />
      <sidebar-row>
        <sidebar-summary-counts
          add-layer-to-project
          show-count-attribute-name-as-title
          :layer-id="geonotesLayerId"
          :counts-attribute-name="geonotesCountAttributeName"
        />
      </sidebar-row>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import SidebarRow from '@/components/SidebarRow';
import SidebarSummaryCounts from '@/components/SidebarSummaryCounts';

export default {
  name: 'GeonotesSummary',
  components: { CardTitleRow, SidebarRow, SidebarSummaryCounts },
  computed: {
    additionalModuleName: get('admin/additionalModules.GEONOTES_MODULE.verbose_name'),
    geonotesLayerId: get('admin/modulesMapping@geonotes.settings.layer_id'),
    geonotesCountAttributeName: get('admin/modulesMapping@geonotes.settings.count_column'),
  },
};
</script>
